<div class="fe-capacities-container">
  <div class="table-actions-bar">
    <div class="table-title">FE Capacities</div>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">Clear All</button>
    <button *ngIf="copiedRows.length > 0 || selectedRows.length > 0" (click)="cancelRow()">Cancel</button>
    <button (click)="addRow()">New</button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button (click)="handleDelete()" [disabled]="!selectedRows.length">Delete</button>
    <button type="button" (click)="openExportDialog()">Export</button>
  </div>

  <div class="spinner-container">
    <mat-spinner *ngIf="spinnerBoolean"></mat-spinner>
  </div>

  <div class="table-container" *ngIf="!spinnerBoolean">
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell fixed-width-cell-1"></div>
        <div class="table-header-cell fixed-width-cell-2">Select</div>
        <div class="table-header-cell"
        *ngFor="let col of columns"
        [ngClass]="{ 'rfsd-width': col.field === 'rfsd', 'ipsomax-width': col.field === 'ipsomax' }"> 
             <div class="col-wrap">
            <div [ngClass]="{'text-wrap': col.lookup || col.field === 'rfsd'}" >
              {{ col.header }}
            </div>
            <div style="width: 20%;display: flex; justify-content: center;align-items: center;">
              <img
                class="filter-icon"
                *ngIf="col.lookup || col.field === 'rfsd'"
                [ngClass]="{ 'active-filter': isFilterActive(col.field) }"
                [src]="isFilterActive(col.field) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                width="16"
                height="16"
                alt="Filter"
                (click)="openFloatingFilter($event, col.field)"
                [title]="isFilterActive(col.field) ? ('Filter applied - ' + col.header) : ('Filter ' + col.header)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-body-container">
      <cdk-virtual-scroll-viewport itemSize="56" class="virtual-scroll-viewport" (scrolledIndexChange)="onScrolledIndexChange($event)">
        <div class="table-body-row"
          (mouseenter)="hoveredRowIndex = i"
          (mouseleave)="hoveredRowIndex = null"
          *cdkVirtualFor="let row of filteredData; let i = index; trackBy: trackByRowId">
          <div class="table-header-cell fixed-width-cell-1">
            <span *ngIf="hoveredRowIndex === i"
              width="16" height="16" style="cursor: pointer;"
              (click)="copyRow(i)"
              title="Copy this row">
              📋
            </span>
          </div>
          <div class="table-header-cell fixed-width-cell-2">
            <input
              type="checkbox"
              [checked]="selectedRows.includes(row)"
              (change)="toggleRowSelection(row, $event)"
              *ngIf="filteredData.includes(row)" 
            />
          </div>
          <div *ngFor="let col of columns"
          class="table-header-cell"
          [ngClass]="{ 'rfsd-width': col.field === 'rfsd', 'ipsomax-width': col.field === 'ipsomax' }"> 
          
          <!-- Develpoment Area -->
            <ng-container *ngIf="col.field == 'developmentArea'">
              <ng-container *ngIf="row.isNew; else readonlyDevArea">
                <div class="cell-wrapper">
                  <select [(ngModel)]="row[col.field]"
                          [disabled]="!col.editable"
                          (change)="onFieldChange(row); handleEdit(row)"
                          (keydown)="handleKeyDown($event, i, col.field)">
                    <option value="">-- Select --</option>
                    <option *ngFor="let option of getLookupOptions(row._rowId, col.field)" [value]="option">{{ option }}</option>
                  </select>
                </div>
                <span *ngIf="col.required" class="required-asterisk">*</span>
              </ng-container>
              <ng-template #readonlyDevArea>
                {{ row[col.field] || '-' }}
              </ng-template>
            </ng-container>

            <!-- Facility Type -->
            <ng-container *ngIf="col.field == 'facilityType'">
              <ng-container *ngIf="row.isNew; else readonlyFacilityType">
                <div class="cell-wrapper">
                  <select [(ngModel)]="row[col.field]"
                          [disabled]="!col.editable"
                          (change)="onFieldChange(row); handleEdit(row)"
                          (keydown)="handleKeyDown($event, i, col.field)">
                    <option value="">-- Select --</option>
                    <option *ngFor="let type of facilityTypeAdminOptions" [value]="type">{{ type }}</option>
                  </select>
                </div>
                <span *ngIf="col.required" class="required-asterisk">*</span>
              </ng-container>
              <ng-template #readonlyFacilityType>
                {{ row[col.field] || '-' }}
              </ng-template>
            </ng-container>

            <!-- Facility Name -->
            <ng-container *ngIf="col.field == 'facilityName'">    
              <ng-container *ngIf="row.isNew; else readonlyFacility">
                <div class="cell-wrapper">
                  <select [(ngModel)]="row[col.field]"
                        [disabled]="!col.editable"
                        (change)="onFieldChange(row);handleFacilityNameChange(row)"
                        (keydown)="handleKeyDown($event, i, col.field)">
                    <option value="">-- Select --</option>
                    <option *ngFor="let option of getLookupOptions(row._rowId, col.field)" [value]="option">{{ option }}</option>
                    <option value="__add_new__">➕ Add New Facility</option>
                  </select>
                </div>
                <span *ngIf="col.required" class="required-asterisk">*</span>
              </ng-container>
              <ng-template #readonlyFacility>
                {{ row[col.field] || '-' }}
              </ng-template>
            </ng-container>

            <!-- Train -->
            <ng-container *ngIf="col.field == 'train'">
              <ng-container *ngIf="row.isNew; else readonlyTrain">
                <div class="cell-wrapper">
                  <select [(ngModel)]="row.train"
                          (keydown)="handleKeyDown($event, i, 'train')">
                    <option *ngFor="let option of lookupData['train']" [ngValue]="option">{{ option }}</option>
                  </select>
                </div>
                <span *ngIf="col.required" class="required-asterisk">*</span>
              </ng-container>
              <ng-template #readonlyTrain>
                {{ row[col.field] || '-' }}
              </ng-template>
            </ng-container>

            <!-- IPSOMAX -->
            <!-- <ng-container *ngIf="col.field == 'ipsomax'">
              <div class="cell-wrapper-ipso">
                <div class="custom-dropdown" (click)="toggleIpsomaxDropdown(row)">
                  {{ row.ipsomax || '- Select -' }}
                </div>
                <div class="dropdown-panel" *ngIf="row.showIpsomaxDropdown">
                  <input type="text"
                        [(ngModel)]="row.ipsomaxSearch"
                        (input)="filterIpsomaxOptions(row)"
                        placeholder="Search IPSOMAX..." />
                  <div class="dropdown-option"
                      *ngFor="let option of row.filteredIpsomax"
                      (click)="selectIpsomaxOption(row, option)">
                    {{ option }}
                  </div>
                </div>
              </div>
            </ng-container> -->

            <!-- RFSD -->
            <ng-container *ngIf="col.field == 'rfsd' " >
              <div class="cell-wrapper">
                <input type="date"
                    [(ngModel)]="row.rfsd"
                    (change)="row._rowEdited = true; handleEdit(row)"
                    (keydown)="handleKeyDown($event, i, col.field)" />
                <span *ngIf="col.required && row.isNew" class="required-asterisk">*</span>
              </div>
            </ng-container>

            <!-- Default: Editable or Readonly Text -->
            <ng-container *ngIf="col.field != 'developmentArea' && col.field != 'facilityType' && col.field != 'facilityName' && col.field != 'train' && col.field != 'ipsomax' && col.field != 'rfsd'">
               <div class="cell-wrapper" [title]="(col.field === 'comments' || col.field === 'selectedOilCapacity' || col.field === 'selectedWaterCapacity' || col.field === 'selectedGasCapacity' || col.field === 'plannedOilCapacity' || col.field === 'plannedWaterCapacity' || col.field === 'plannedGasCapacity') ? row[col.field] : null">    
                  <ng-container *ngIf="col.editable; else readonlyText">
                  <input type="text"
                      [(ngModel)]="row[col.field]"
                      (change)="row._rowEdited = true"
                      (blur)="handleEdit(row)"
                      (keydown)="handleKeyDown($event, i, col.field)" />
                  <span *ngIf="col.required && row.isNew" class="required-asterisk">*</span>
                </ng-container>
                <ng-template #readonlyText>
                  {{ row[col.field] || '-' }}
                </ng-template>
              </div>
            </ng-container>
          </div> 
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
<!-- Floating Filter Box -->
<div class="floating-filter-dropdown"
     *ngIf="showFloatingFilter && activeFilter !== 'rfsd'"
     [ngStyle]="{ top: dropdownPosition.top + 'px', left: dropdownPosition.left + 'px' }">
  <input type="text" [(ngModel)]="filterSearch[activeFilter]" placeholder="Search..." />

  <div *ngIf="isLoadingFilterOptions" class="filter-loading">
    <div class="spinner-small"></div>
    Loading options...
  </div>

  <div *ngIf="!isLoadingFilterOptions" class="filter-options">
    <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
      No options available
    </div>
    <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
      {{ getFilterOptions(activeFilter).length }} options available
    </div>
    <label *ngFor="let option of getFilterOptions(activeFilter)">
      <input type="checkbox"
             [checked]="isChecked(activeFilter, option)"
             (change)="toggleMultiFilter(activeFilter, option, $event)" />
      <span>{{ option }}</span>
    </label>
  </div>

  <div class="filter-buttons">
    <button (click)="applyFilter(activeFilter)">Apply</button>
    <button (click)="clearFilter(activeFilter)">Clear</button>
  </div>
</div>
<!-- RFSD Filter -->
<div class="floating-filter-dropdown"
     *ngIf="showFloatingFilter && activeFilter === 'rfsd'"
     [ngStyle]="{ top: dropdownPosition.top + 'px', left: dropdownPosition.left + 'px' }">
  <label>Start</label>
  <input type="date" [(ngModel)]="rfsFilter.start" />
  <label>End</label>
  <input type="date" [(ngModel)]="rfsFilter.end" />
  <div class="filter-buttons">
    <button (click)="applyFilter('rfsd')">Apply</button>
    <button (click)="clearFilter('rfsd')">Clear</button>
  </div>
</div>
<!-- Add Facility Modal -->
<div class="modal-overlay" *ngIf="showAddFacilityModal">
  <div class="modal-content">
    <h3>Add New Facility</h3>
 
    <div class="modal-field">
      <label>Development Area:<span class="required-asterisk">*</span></label>
      <select [(ngModel)]="newFacility.developmentArea">
        <option value="">-- Select --</option>
        <option *ngFor="let area of devAreaAdminOptions" [value]="area">{{ area }}</option>
      </select>
    </div>
 
    <div class="modal-field">
      <label>Facility Type:<span class="required-asterisk">*</span></label>
      <select [(ngModel)]="newFacility.facilityType">
        <option value="">-- Select --</option>
        <option *ngFor="let type of facilityTypeAdminOptions" [value]="type">{{ type }}</option>
      </select>
    </div>
 
    <div class="modal-field">
      <label>Facility Name:<span class="required-asterisk">*</span></label>
      <input type="text" [(ngModel)]="newFacility.facilityName" />
    </div>
 
    <div class="modal-buttons">
      <button (click)="saveNewFacility()">Save</button>
      <button (click)="cancelAddFacility()">Cancel</button>
    </div>
  </div>
</div>

<!-- Delete confirmation dialog template -->
<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export FE Capacities</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>
